import { useRecoilValue } from "recoil";
import { ModalState } from "../recoil/modal";
import { createPortal } from "react-dom";
import * as modalComponents from '../modals';
import { createElement } from "react";
import { ModalTemplate } from "../components";


const Modal = () => {
    const modals = useRecoilValue(ModalState);
    const modalEle = document.getElementById('modal');

    if(!modalEle) return <></>;
    return createPortal(
        <>
            {modals.map((modal) => (
                <ModalTemplate key={modal.hash}>
                    {createElement(modalComponents[modal.type], {
                        hash: modal.hash,
                        payload: modal.payload,
                    })}
                </ModalTemplate>
            ))}
        </>,
        modalEle,
    );
}

export default Modal;